import {map} from 'rxjs/operators';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';

import Models from './models';
import type * as Types from './types';

export const lists = (institutionId: string) => {
    return RESTClient.getAuthenticatedObservable('v2/filter/presets', {
        institutionId,
    }).pipe<Types.ListsResponse>(
        map(lists => {
            return Models.fromAPI(lists);
        }),
    );
};

export const deleteList = (listId: string) => {
    return RESTClient.deleteAuthenticatedObservable(`v2/filter/presets/${listId}`);
};
